import React from "react";
class TeamStatus extends React.Component {
    state = {
        statuses: [
            {
                value: 'active',
                label: 'Active'
            },
            {
                value: 'suspended',
                label: 'Suspended'
            }
        ]
    };

    render() {
        return (
            <React.Fragment>
                <form autoComplete="off" className="form form--horizontal" > 
                    <select 
                        value={this.props.member.status} 
                        name="Status" 
                        onChange={(event) => this.props.updateStatus(this.props.member, event.target.value)} 
                        className="react-tags__selected-tag" >
                        {this.state.statuses.map(status => ( <option value={status.value} key={status.value}>{status.label}</option> ))}
                    </select>
                </form>
            </React.Fragment>
        );
    }
}

export default TeamStatus;
